/*
 * SummitAttentive — forwards a phone number (+ contact details) to Attentive
 * for SMS marketing.
 *
 * Why a server endpoint instead of a direct call?
 * Attentive's Subscribe API requires a PRIVATE API key, which must never be
 * exposed in browser JavaScript. So this module POSTs to a same-origin endpoint
 * (a Shopify App Proxy or serverless function) that holds the key server-side
 * and forwards the request to Attentive. See ATTENTIVE_SETUP.md.
 *
 * Until that endpoint is deployed and its URL is set in the section settings,
 * this module is dormant: it logs a warning and does nothing, so the rest of
 * the form (email + quiz -> Klaviyo) keeps working.
 */
(function () {
  if (window.SummitAttentive) return;

  window.SummitAttentive = {
    subscribe: function (payload) {
      payload = payload || {};

      if (!payload.phone) return; // nothing to send

      if (!payload.endpoint) {
        console.warn(
          '[SummitAttentive] No endpoint configured — phone not sent to Attentive. ' +
            'Set the Attentive endpoint URL in the giveaway section settings once the server endpoint is live.'
        );
        return;
      }

      var body = {
        phone: payload.phone,
        email: payload.email || '',
        first_name: payload.first_name || '',
        last_name: payload.last_name || '',
        source: payload.source || 'Giveaway',
      };

      // Fire-and-forget. keepalive lets the request survive a page transition.
      fetch(payload.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
      }).catch(function () {
        // Non-blocking: the user already saw the success state from Klaviyo.
      });
    },
  };
})();
